import { useState } from "react";

import Modal from "~/components/ui/modal";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { PartnershipType } from "~/types/partnership/partnership.types";

import MembershipPartners from "../partners";
import styles from "./index.module.scss";
import SelectionMembership from "./membership";

type Props = {
  partnerships: PartnershipType[];
};

const MembershipSelection = ({ partnerships }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const { language } = useLanguage();

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const perks =
    language === "En"
      ? englishTranslations.membershipPage.memberPerks
      : frenchTranslations.membershipPage.memberPerks;

  return (
    <>
      <section className={styles.membershipSelection}>
        <div className={styles.membershipsContainer}>
          <SelectionMembership type={"MEMBER"} perks={perks} />
        </div>
      </section>
      <Modal open={modalOpen} showAnimation="expand" onClose={handleCloseModal}>
        <MembershipPartners
          handleCloseModal={handleCloseModal}
          partnerships={partnerships}
        />
      </Modal>
    </>
  );
};

export default MembershipSelection;
